import { DestroyRef, inject, Signal, signal } from '@angular/core';

// Heure courante (epoch ms), mise a jour a intervalle regulier pour les comptes a rebours.
// A appeler dans un contexte d'injection : l'horloge s'arrete avec lui.
export function injectNow(intervalMs = 1000): Signal<number> {
  const now = signal(Date.now());
  const timer = setInterval(() => now.set(Date.now()), intervalMs);
  inject(DestroyRef).onDestroy(() => clearInterval(timer));
  return now.asReadonly();
}
